import { ObjectDataset } from "@tblabs/storage";
import { BlogArticle } from "../../Models/Blog/BlogArticle";
import { BlogContent } from "../../Models/Blog/BlogContent";
import { ProductCategory } from "../../Models/Product/ProductCategory";
import { BlogCategory } from "./BlogCategory";
import { ContentProvider } from "./ContentProvider";


export class BlogContentProvider extends ContentProvider<BlogContent>
{
    public get Blog(): BlogContent
    {
        return this.Content;
    }

    constructor(_repo: ObjectDataset<BlogContent>)
    { 
        super(_repo);
    }

    public async GetPublicCategories(): Promise<BlogCategory[]>
    {
        const categories = await this.GetByCategory();
        
        return [...categories.map(x => ({ ...x, Articles: x.Articles.filter(y => y.Visible.value) }))];
    }

    public async GetByCategory(): Promise<BlogCategory[]>
    {
        const articlesByCategory: BlogCategory[] = [];

        for (const article of this.Blog.Articles.Items)
        {
            const categoryName = article.Category.value || "Inne";

            const category = articlesByCategory.find(x => x.Name === categoryName);
            if (!category)
            {
                const newCategory = { Name: categoryName, Articles: [article] };
                articlesByCategory.push(newCategory);
            }
            category?.Articles?.push(article);
        }

        return articlesByCategory;
    }

    public ArticlesRelatedToCategory(category: ProductCategory): BlogArticle[]
    {
        const articles = this.Blog.Articles?.Items.filter(x => category?.RelatedArticles.Items.includes(x.Id));

        return articles || [];
    }
}
